import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Card, Table, Button, notification,Modal, Pagination } from "antd";
import { Dropdown } from "antd";
import { CheckCircleFilled, DeleteOutlined, ExclamationCircleFilled, EyeOutlined, InfoCircleFilled, MoreOutlined, RocketOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import {
  getCategoryListAction,
  getHSCodeAction,
  getProductsAction,
  deleteProductAction,
} from "../../appRedux/actions/myProductsAction";
import { useHistory } from "react-router-dom";
import {
  isArrayNonEmpty,
  isValidElement,
  isValidString,
} from "../../util/ApiHelper";
import EnquiryStatusTags from "../../admin/enquiries/EnquiriesStatus";
import ListEmptyComponent from "../../components/ListEmptyComponent/ListEmptyComponent";
import { useGetBreakpoints } from "../../hooks/useGetBreakpoints";
import { ItemDetailMobile } from "../../components/ItemDetailMobile";
import { axiosInstance, BASE_API_CONFIG } from "../../util/Api";

const MyProductsList = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { isMobile } = useGetBreakpoints();
  




   const productList = useSelector((state) => state.myProducts.productsList);
   const { loading } = useSelector(({ common }) => common);
  //  const userSubscription = useSelector((state) => state.auth?.userData?.subscription);
  const[userSubscription,setUserSubscription] =useState(null);
    console.log("productLimit", userSubscription?.subscription?.planId)

   const authUser = useSelector(({ auth }) => auth.userData);

  console.log("authUser",authUser)
  console.log("userSubscription",userSubscription)
   const userData = useSelector(({ auth }) => auth?.userData);
    const userId=userData.id;
    console.log("userId",userId)
    const [subscriptionData, setSubscriptionData] = useState(null);
    console.log("subscriptionData",subscriptionData)
    const [showSubscriptionPlans, setShowSubscriptionPlans] = useState(false);
    const [error, setError] = useState(null);
    const [loadings, setLoadings] = useState(false);
    const [productLimits, setProductLimits] = useState({
        free: undefined,
        basic: undefined,
        premium:undefined,
      });
    console.log("productLimits", productLimits)
    const [limitsError, setLimitsError] = useState(null);


  useEffect(() => {
    const fetchProductLimits = async () => {
      try {
        const response = await axiosInstance.get(
                  `${BASE_API_CONFIG.baseURL}/products/product-limits`
        );
        if (response.data) {
          setProductLimits(response.data);
        } else {
          setLimitsError('No limit configuration found');
        }
      } catch (error) {
        console.error('Failed to fetch product limits:', error);
        setLimitsError(error.response?.data?.message || 'Failed to load limits');
      }
    };
  
    fetchProductLimits();
  }, []);

  const fetchSubscription = async () => {
    try {
      setLoadings(true);
      const response = await axiosInstance.get(
        `${BASE_API_CONFIG.baseURL}/subscription-plans/user/${userId}`
      );
      setSubscriptionData(response.data);
      setUserSubscription(response.data.subscription);
      
      if (!response.data.isActive) {
        setShowSubscriptionPlans(true);
      }
    } catch (err) {
      console.error('Subscription fetch error:', err);
    } finally {
      setLoadings(false);
    }
  };

  useEffect(() => {
    fetchSubscription();
    dispatch(getProductsAction());
  }, [dispatch, userId]);

  // Product limit calculation
  const productLimit = useMemo(() => {
    if (!userSubscription) return 5;
    
    const isSubscriptionExpired = userSubscription.endDate 
      ? new Date(userSubscription.endDate) < new Date()
      : false;

    if (isSubscriptionExpired) return 5;

    switch (subscriptionData.subscription?.planId) {
    case 1: return productLimits.FREE;
    case 2: return productLimits.BASIC;
    case 3: return productLimits.PREMIUM;
    default: return productLimits.FREE;
  }
}, [userSubscription, productLimits]);

  const currentProductCount = useMemo(() => {
    return productList?.rows?.length || 0;
  }, [productList]);

  const canCreateMoreProducts = currentProductCount < productLimit;

  // Product limit check
  const checkProductLimit = useCallback(() => {
    if (!userSubscription) {
      notification.warning({
        message: "Subscription Loading",
        description: "Please wait while we verify your subscription",
      });
      return false;
    }

    if (!canCreateMoreProducts) {
      // eslint-disable-next-line no-undef
      Modal.confirm({
      title: (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <ExclamationCircleFilled style={{ color: '#faad14', fontSize: 20 }} />
          <span>Product Limit Reached</span>
        </div>
      ),
      icon: null, // We're customizing the title instead
      width: 500,
      centered: true,
      content: (
        <div style={{ padding: '14px 0' }}>
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: 12,
            padding: '12px 16px',
            backgroundColor: '#fffbe6',
            borderRadius: 8,
            marginBottom: 12
          }}>
            <InfoCircleFilled style={{ color: '#faad14', fontSize: 18 }} />
            <div>
              <p style={{ margin: 0, fontWeight: 500 }}>You've reached your free tier limit</p>
              <p style={{ margin: '4px 0 0 0', color: '#666' }}>
                {/* {currentCount}/{productLimit} freight rates used */}
              </p>
            </div>
          </div>
          
          <div style={{ marginBottom: 20 }}>
            <h4 style={{ marginBottom: 8 }}>Upgrade Benefits:</h4>
            <ul style={{ 
              margin: 0, 
              paddingLeft: 20,
              listStyleType: 'none'
            }}>
              <li style={{ marginBottom: 8, display: 'flex', alignItems: 'flex-start' }}>
                <CheckCircleFilled style={{ color: '#52c41a', marginRight: 8, marginTop: 4 }} />
                <span> Can Add 10-20 Products</span>
              </li>
              <li style={{ marginBottom: 8, display: 'flex', alignItems: 'flex-start' }}>
                <CheckCircleFilled style={{ color: '#52c41a', marginRight: 8, marginTop: 4 }} />
                <span>Priority listing in Product marketplace</span>
              </li>
              <li style={{ display: 'flex', alignItems: 'flex-start' }}>
                <CheckCircleFilled style={{ color: '#52c41a', marginRight: 8, marginTop: 4 }} />
                <span>Advanced analytics dashboard</span>
              </li>
            </ul>
          </div>
          
          {/* <div style={{ 
            backgroundColor: '#f6ffed',
            border: '1px solid #b7eb8f',
            borderRadius: 8,
            padding: 12
          }}>
            <p style={{ margin: 0, display: 'flex', alignItems: 'center' }}>
              <StarFilled style={{ color: '#faad14', marginRight: 8 }} />
              <span>Premium members get 2x more leads on average</span>
            </p>
          </div> */}
        </div>
      ),
      okText: (
        <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <RocketOutlined />
          Upgrade Plan
        </span>
      ),
      cancelText: "Maybe Later",
      okButtonProps: {
        style: { background: '#1890ff', borderColor: '#1890ff' }
      },
      onOk: () => history.push("/subscription-User"),
    });
      return false;
    }
    return true;
  }, [userSubscription, canCreateMoreProducts, productLimit, history]);


  useEffect(() => {
    dispatch(getProductsAction());
    dispatch(getCategoryListAction());
    dispatch(getHSCodeAction());
    if (userSubscription === undefined) {
      dispatch(userSubscription());
    }
  }, [dispatch, userSubscription]);



  const onShowSizeChange = useCallback((current, pageSize) => {
    console.log('@@@ on Show size change')
    dispatch(getProductsAction(current, pageSize));
  }, [dispatch]);
  
  const onProductClick = useCallback((item) => {
    dispatch(deleteProductAction(item?.id));
    dispatch(getProductsAction(1, 10));
  }, [dispatch]);

  const navigateToDetails = useCallback((id) => {
    if (isValidElement(id)) {
      history.push(`my-products/details?id=${id}`);
    } else {
      history?.push("my-products/edit");
    }
  }, [history]);

  const handleCreateProduct = useCallback(() => {
    if (!checkProductLimit()) return;
    navigateToDetails();
  }, [checkProductLimit, navigateToDetails]);

  const moreActionsRenderer = useCallback((record) => (
    <div className="myexim-action-icon" onClick={(e) => e.stopPropagation()}>
      <Dropdown
        menu={{
          items: [
            {
              label: "View",
              key: "1",
              icon: <EyeOutlined />,
              onClick: () => {
                navigateToDetails(record?.id);
              },
            },
            {
              label: "Delete",
              key: "2",
              icon: <DeleteOutlined />,
              onClick: () => {
                onProductClick(record);
              },
            },
          ],
        }}
        trigger={["click"]}
      >
        <MoreOutlined />
      </Dropdown>
    </div>
  ), [navigateToDetails, onProductClick]);

  const columns = useMemo(() => [
    {
      title: "Product Name",
      key: "Product Name",
      dataIndex: "name",
      sorter: true,
      width: "25%",
      render: (text, record) => (
        <div className={"gx-flex-row gx-align-items-center"}>
          <div className={"gx-pr-2"}>
            <img
              alt="..."
              className={"gx-size-40 gx-rounded-base gx-border-2"}
              src={isValidString(record?.primaryImage) && record?.primaryImage}
            />
          </div>
          <div className={"highlighted-column"}>{text}</div>
        </div>
      ),
    },
    {
      title: "Category",
      key: "Product Name",
      sorter: true,
      width: "25%",
      render: (record) => <div>{record?.categories?.name}</div>,
    },
    {
      title: "HS Code",
      key: "hsCode",
      render: (record) => <div>{record?.hscode?.code}</div>,
    },
    {
      title: "Status",
      key: "Status",
      sorter: true,
      render: (record) => {
        return <EnquiryStatusTags status={record?.status} />;
      },
    },
    {
      title: "Actions",
      key: "actions",
      render: moreActionsRenderer,
    },
  ], [moreActionsRenderer]);

  const renderContent = useCallback((data, count) => {
    return isMobile ? (
      <>
      <Card bodyStyle={{ padding: 0 }}>
       {data.map((record) => {
        return (
          <ItemDetailMobile
            imgData={{
              name: record.images?.[0].originalName,
              src: record.primaryImage,
            }}
            primaryRow={{
              text: record.name,
            }}
            secondaryRow={{
              text: `HS Code: ${record.hscode.code}`,
            }}
            status={record.status}
            StatusComponent={EnquiryStatusTags}
            MoreActions={() => moreActionsRenderer(record)}
            handleNavigation={() => {
              navigateToDetails(record.id)
            }}
          />
        )
      })}
      </Card>
      <Pagination
        total={count}
        pageSize={10}
        onChange={onShowSizeChange}
        showSizeChanger
        style={{ marginTop: 16, textAlign: "right",paddingRight:10 }}
        showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
      />
      </>
    ) : (
      <Table
        rowClassName={(_, index) =>
          index % 2 === 0 ? "table-row-light" : "table-row-dark"
        }
        onRow={(record) => {
          return {
            onClick: () => {
              navigateToDetails(record?.id);
            },
          };
        }}
        className="gx-table-responsive my-product-table myexim-table"
        total={count}
        columns={columns}
        dataSource={data}
        pagination={{
          position: ["bottomRight"],
          showSizeChanger: true,
          pageSize: 10,
          total: count,
          onChange: onShowSizeChange,
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} of ${total} items`,
        }}
        footer={() => {
          if (count > 0) {
            const currentCount = data?.length || 0;
            const shouldShowUpgrade = userSubscription?.planId !== 3;

            return (
              <div style={{
                padding: "10px 0",
                fontWeight: "bold",
                borderTop: "1px solid #d9d9d9",
              }}>
                {!canCreateMoreProducts ? (
          <div style={{ color: '#ff4d4f' }}>
            You've reached your product limit ({currentCount}/{productLimit})  
            {shouldShowUpgrade && (
              <Button 
                type="link" 
                onClick={() => history.push('/subscription-User')}
                style={{ 
                  padding: '0 4px',
                  fontWeight: 600,
                  border: '1px solid #1890ff',
                  borderRadius: '4px',
                  marginLeft: '8px'
                }}
              >
                Upgrade Now
              </Button>
            )}
          </div>
        ) : (
          <div>
            Note: Your Products with "Pending Approval" status require
            review by our team and will be approved or rejected within 24
            hours.
            <div style={{ marginTop: 8 }}>
              Products: {currentCount}/{productLimit}
            </div>
          </div>
        )}
              </div>
            );
          }
          return null;
        }}
      />
    );
  }, [columns, isMobile, navigateToDetails, onShowSizeChange, canCreateMoreProducts, productLimit, userSubscription?.planId, history,moreActionsRenderer]);

  return (
    <Card
      // className={isMobile ? 'mobile-view': ''}
      bodyStyle={{ padding: 0 }}
      title={
        <div style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}>
          <div className="myexim-table-title" >My Products</div>
          {isArrayNonEmpty(productList?.rows) && (
            <div style={{ paddingLeft: 15 }}>
              <Button type="primary" 
             
                onClick={() => {
                  if (!userSubscription) {
                    notification.info({
                      message: "Free Account",
                      description: "You're using the free version with limited features",
                    });
                  }
                  if (!checkProductLimit()) return;
                  navigateToDetails();
                }}
                >
                {isMobile ? "+" : "+ Create New Product"}
              </Button>
            </div>
          )}
        </div>
      }
    >
      <div>
        {isArrayNonEmpty(productList?.rows) ? renderContent(productList.rows, productList.count) : (
          !loading && (
            <ListEmptyComponent
              message="Create Your Products to get the Enquiries for your Listed Products."
              buttonText="+Create Your New Products"
              onButtonClick={handleCreateProduct}
              buttonDisabled={!canCreateMoreProducts}
            />
          )
        )}
      </div>
    </Card>
  );
};

export default MyProductsList;
